import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import SequenceTemplateData from "Stores/sequence/SequenceTemplateData";
import { seqTemplatePopupState } from "./SeqTemplatePopupState";
import CustomRadioButton from "Components/common/customRadioBtn";

const PredefinedTemplates = (props) => {
  const { 
    selectedPredefinedTemplate, 
    predefinedTemplateList 
  } = SequenceTemplateData;

  const getSeqTemplateAndLoad = (item) => {
    SequenceTemplateData.setSelectedPredefinedTemplate(item);
    SequenceTemplateData.setSeqTemmplateClicked(true);
  };

  useEffect(() => {
    SequenceTemplateData.getSeqPredefinedTemplate();
  }, []);

  const radioOnchangeAction = (e, item) => {
    e.stopPropagation();
    SequenceTemplateData.setSelectedPredefinedTemplate(item);
    SequenceTemplateData.setSeqTemmplateClicked(true);
  };

  return (
    <div className="predefinedTemplatesSection">
      <div className="TemplateList">
        {predefinedTemplateList && predefinedTemplateList.length > 0 ? (
          predefinedTemplateList.map((item, index) => {
            const currentSelected = SequenceTemplateData.selectedPredefinedTemplate;
            const isSelected = !!(currentSelected && 
              ((item.id && currentSelected.id === item.id) || 
               (item._id && currentSelected._id === item._id)));
            
            return (
              <div
                className={`templateItem ${isSelected ? "activeTemplate" : ""}`}
                id={`template-item-${item.id || item._id || index}`}
                key={`template-row-${item.id || item._id || index}`}
                onClick={() => getSeqTemplateAndLoad(item)}
              >
                <div className="radioSection">
                  <CustomRadioButton
                    id={`radio-btn-${item.id || item._id || index}`}
                    name="email_predefined_template_group"
                    radioValue={item.id || item._id}
                    labelText=""
                    checked={isSelected}
                    radioOnchange={(e) => radioOnchangeAction(e, item)}
                  />
                </div>
                <div className="templateDetailInfo">
                  <h6 className="title">{item.name}</h6>
                  <p className="descText">{item.description}</p>
                </div>
              </div>
            );
          })
        ) : (
          Array.from({ length: 3 }).map((_, index) => (
            <div
              className="templateItem templateCardLoader"
              key={`usePredefinedTemplateLoader-${index}`}
            >
              <div className="radioSection loader">
                <div className="radioCircle linear-background"></div>
              </div>
              <div className="templateDetailInfo">
                <h6 className="title linear-background">&nbsp;</h6>
                <div className="descTextLoader linear-background"></div>
                <div className="descTextLoader linear-background"></div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default observer(PredefinedTemplates);
export { PredefinedTemplates };
